export type RoleJobQuery = {
  param: 'role' | 'search';
  value: string;
  ctaLabel?: string;
  legacyLabels: string[];
};

// Role landing pages are more specific than the scraper's broad role taxonomy.
// Use exact text search where no truthful canonical role exists.
export const ROLE_JOB_QUERIES: Record<string, RoleJobQuery> = {
  'audio-engineer': {
    param: 'search',
    value: 'Audio Engineer',
    legacyLabels: ['Audio Engineer'],
  },
  'audio-technician': {
    param: 'search',
    value: 'Audio Technician',
    legacyLabels: ['Audio Tech'],
  },
  'video-engineer': {
    param: 'search',
    value: 'Video',
    ctaLabel: 'Find Video Gigs',
    legacyLabels: ['Video Engineer'],
  },
  'video-technician': {
    param: 'search',
    value: 'Video Technician',
    legacyLabels: ['Video Tech'],
  },
  'lighting-designer': {
    param: 'search',
    value: 'Lighting Designer',
    legacyLabels: ['Lighting Designer'],
  },
  'lighting-technician': {
    param: 'role',
    value: 'lighting_tech',
    legacyLabels: ['Lighting Tech'],
  },
  stagehand: {
    param: 'role',
    value: 'stagehand',
    legacyLabels: ['Stagehand'],
  },
  rigger: {
    param: 'role',
    value: 'rigger',
    legacyLabels: ['Rigger'],
  },
  'stage-manager': {
    param: 'search',
    value: 'Stage Manager',
    legacyLabels: ['Stage Manager'],
  },
  'led-technician': {
    param: 'search',
    value: 'LED',
    legacyLabels: ['LED Tech'],
  },
  'camera-operator': {
    param: 'role',
    value: 'camera_operator',
    legacyLabels: ['Camera Op'],
  },
  'production-assistant': {
    param: 'role',
    value: 'production_assistant',
    legacyLabels: ['Production Assistant'],
  },
};

function normalizeLegacyLabel(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, ' ');
}

const LEGACY_ROLE_QUERIES = Object.values(ROLE_JOB_QUERIES).reduce<Record<string, RoleJobQuery>>(
  (queries, query) => {
    query.legacyLabels.forEach(label => {
      queries[normalizeLegacyLabel(label)] = query;
    });
    return queries;
  },
  {},
);

export function resolveLegacyRoleQuery(role: string): RoleJobQuery | null {
  return LEGACY_ROLE_QUERIES[normalizeLegacyLabel(role)] || null;
}
